// // ProfileLogout.jsx

import { Link, useNavigate } from 'react-router-dom';
import { handleLogout } from './AuthUtils';
import './ProfileLogout.css'; // Add this line for custom styles
import { getUser } from '../utils/auth';

const ProfileLogout = () => {
  const navigate = useNavigate();
  const user = getUser() || "Guest"

  const onButtonClick = () => {
    handleLogout();
    navigate('/login');
  };

  return (
    <div className="profile-card">
      <div className="profile-header">👤 Profile</div>
      <div className="profile-body">
        <p className="profile-welcome">Welcome, <strong>{user?.name}</strong></p>
        <Link to="#" className="logout-button" onClick={onButtonClick}>
          🔓 Logout
        </Link>
      </div>
    </div>
  );
};

export default ProfileLogout;
